export interface GetTenantInfoResponse {
  exists: boolean
}
